import { z } from 'zod';

// Contact form validation schema
export const contactFormSchema = z.object({
  name: z.string()
    .min(2, 'Jméno musí mít alespoň 2 znaky')
    .max(100, 'Jméno může mít maximálně 100 znaků')
    .regex(/^[a-zA-ZáčďéěíňóřšťúůýžÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ\s]+$/, 'Jméno může obsahovat pouze písmena'),
  email: z.string()
    .email('Neplatná emailová adresa')
    .max(255, 'Email může mít maximálně 255 znaků'),
  message: z.string()
    .min(10, 'Zpráva musí mít alespoň 10 znaků')
    .max(5000, 'Zpráva může mít maximálně 5000 znaků')
});

export type ContactFormData = z.infer<typeof contactFormSchema>;

// Database contact type
export interface Contact extends ContactFormData {
  id: number;
  ip_address: string | null;
  user_agent: string | null;
  created_at: string;
  status: 'unread' | 'read';
}